import fetchSubcontractors from '../Services/fetchSubcontractors';

export default () => async (dispatch) => {

  dispatch(fetchSubcontractors());
  
}